import React from "react";
import Parse from "parse";
import { useState, useEffect } from "react";
import { Image, Text, Box, Flex } from "@chakra-ui/react";
import "./ShowUser.css";
import { useNavigate } from "react-router-dom";
import imageUp from "../../Variant3.png";

function ShowUser({
  userId,
  unseen,
  offre,
  hide,
  showMetier,
  showAvatarOnly,
  visiteursProfile,
  offerId,
  userEvent,
}) {
  const navigate = useNavigate();

  async function fetchUser() {
    const User = Parse.Object.extend("User");
    const query = new Parse.Query(User);
    query.equalTo("objectId", userId);
    const fetchedUser = await query.find();
    setUser(fetchedUser);
    return fetchedUser;
  }

  const [user, setUser] = useState();
  const [notseen, setNotseen] = useState(true);

  const onClick = () => {
    console.log("showAvatarOnly");
    console.log(showAvatarOnly);
    console.log("showAvatarOnly");
    if (showAvatarOnly) {
      if (visiteursProfile.get("seen") == false) {
        visiteursProfile.set("seen", true);
        visiteursProfile.save().then(
          (visiteursProfile) => {
            navigate(`/DetailUser/${userId}`);
          },
          (error) => {
            alert("Failed to update Offer, with error code: " + error.message);
          }
        );
      }
    } else if (unseen && notseen && offre !== undefined) {
      console.log("showAvatarOnly");
      let listUnseenUser = offre.get("listUnseenUser");
      var filtered = listUnseenUser.filter(function (value, index, arr) {
        return value !== userId;
      });
      setNotseen(false);
      if (filtered.length <= 0) {
        offre.set("isUnseen", false);
      }
      offre.set("listUnseenUser", filtered);
      offre.save().then(
        (offre) => {
          navigate(`/DetailUser/${userId}&${offre["id"]}`);
        },
        (error) => {
          alert("Failed to update Offer, with error code: " + error.message);
        }
      );
    } else if (userEvent === true) {
      navigate(`/DetailUser/${userId}`);
    } else {
      navigate(`/DetailUser/${userId}&${offre["id"]}`);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  useEffect(() => {
    if (!user) return;
  }, [user]);

  return (
    <Box>
      {user && showAvatarOnly ? (
        <Box>
          {user.length > 0 ? (
            <a onClick={onClick}>
              <Image
                border={"8px"}
                borderColor="white"
                src={
                  user[0].get("avatar") ? user[0].get("avatar").url() : imageUp
                }
                borderRadius="full"
                boxSize="50px"
              />
            </a>
          ) : (
            ""
          )}
        </Box>
      ) : (
        ""
      )}

      {user && !showAvatarOnly ? (
        <Box>
          {user.length > 0 ? (
            <Box>
              {unseen && !hide ? "new" : ""}
              <a onClick={onClick}>
                {" "}
                <Flex>
                  <Box>
                    <Image
                      border={"8px"}
                      borderColor={"white"}
                      src={
                        user[0].get("avatar")
                          ? user[0].get("avatar").url()
                          : "public/user.png"
                      }
                      borderRadius="full"
                      boxSize="60px"
                    />
                  </Box>
                  <Box>
                    {user[0].get("prenom") && user[0].get("nom") ? (
                      <Box ml={"20px"}>
                        <Text
                          ml={"1px"}
                          fontWeight={900}
                          fontFamily={"Sofia Pro"}
                        >
                          {user[0].get("prenom")} {user[0].get("nom")}
                        </Text>
                        <Text fontWeight={400} fontFamily={"Sofia Pro"}>
                          {showMetier ? user[0].get("current_job") : ""}
                        </Text>
                      </Box>
                    ) : (
                      ""
                    )}
                  </Box>
                </Flex>
              </a>
            </Box>
          ) : (
            " "
          )}
        </Box>
      ) : (
        ""
      )}
    </Box>
  );
}

export default ShowUser;
